var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIndeterminateSpinnerSmallDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "#fff"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.18,
  d: "M5 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.73,
  d: "M19 9h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.47,
  d: "M10 15a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 0a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.05,
  d: "M6.366 1.706a1 1 0 1 0-1.732 1l1.5 2.598a1 1 0 0 0 1.732-1l-1.5-2.598Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.6,
  d: "M13.866 14.696a1 1 0 0 0-1.732 1l1.5 2.598a1 1 0 1 0 1.732-1l-1.5-2.598Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.26,
  d: "M5.67 12.5a1 1 0 0 0-1.366-.366l-2.598 1.5a1 1 0 1 0 1 1.732l2.598-1.5A1 1 0 0 0 5.67 12.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.82,
  d: "M14.33 7.5a1 1 0 0 0 1.366.366l2.598-1.5a1 1 0 1 0-1-1.732l-2.598 1.5A1 1 0 0 0 14.33 7.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.1,
  d: "m1.706 6.366 2.598 1.5a1 1 0 1 0 1-1.732l-2.598-1.5a1 1 0 1 0-1 1.732Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.64,
  d: "m18.294 13.634-2.598-1.5a1 1 0 1 0-1 1.732l2.598 1.5a1 1 0 1 0 1-1.732Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.4,
  d: "M7.5 14.33a1 1 0 0 0-1.366.366l-1.5 2.598a1 1 0 1 0 1.732 1l1.5-2.598A1 1 0 0 0 7.5 14.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.85,
  d: "M12.5 5.67a1 1 0 0 0 1.366-.366l1.5-2.598a1 1 0 1 0-1.732-1l-1.5 2.598A1 1 0 0 0 12.5 5.67Z"
}))));
export { SvgIndeterminateSpinnerSmallDark as ReactComponent };
export default __webpack_public_path__ + "static/media/indeterminate-spinner-small-dark.cd16e176958eee50437c.svg";